// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"264150af","85":"2ad99c09","192":"1cd849b0","217":"4f55cd3b","318":"c658b05c","666":"32d7218a","717":"5264b699","720":"eddc7015","787":"9e9f4ffd","826":"a9fe9e6c","839":"dd79addf","966":"a6ed6485"}[chunkId] + ".chunk.js";
};